"use server";

/**
 * app/actions/kudos-client.ts
 *
 * Thin wrapper functions for server actions called from client components.
 *
 * Next.js 16 "use server" files may only export async functions defined
 * directly in the file — re-exports are not allowed. Each function here
 * is a one-line pass-through to the real implementation in kudos.ts.
 *
 * Client components import from here. Server components import from kudos.ts.
 */

import {
  placeMatchBet as _placeMatchBet,
  placeFuturesBet as _placeFuturesBet,
  transferKudos as _transferKudos,
  getMatchupOdds as _getMatchupOdds,
} from "./kudos";

export type { LeaderboardEntry } from "./kudos";

export async function placeMatchBet(
  matchupId: string,
  predictedWinnerId: string,
  wager: number
) {
  return _placeMatchBet(matchupId, predictedWinnerId, wager);
}

export async function placeFuturesBet(nameId: string, wager: number) {
  return _placeFuturesBet(nameId, wager);
}

export async function transferKudos(
  toUserId: string,
  amount: number,
  note?: string
) {
  return _transferKudos(toUserId, amount, note);
}

export async function getMatchupOdds(matchupId: string) {
  return _getMatchupOdds(matchupId);
}
